var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 12,
    viewBox: "0 0 34 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0222 1.12124L14.848 11.2848H12.2189L14.3935 1.12124H17.0222ZM28.0839 7.68387L29.4681 3.86711L30.2646 7.68387H28.0839ZM31.0173 11.2848H33.4492L31.3271 1.12124H29.0824C28.578 1.12124 28.1524 1.41461 27.963 1.86689L24.0185 11.2848H26.7795L27.3276 9.76709H30.7008L31.0173 11.2848ZM24.1555 7.96631C24.1668 5.2838 20.4459 5.13615 20.4716 3.93789C20.4794 3.57278 20.8271 3.18547 21.5866 3.08607C21.9639 3.03685 23.0013 2.99922 24.1793 3.54125L24.6406 1.38598C24.0079 1.1563 23.1937 0.935303 22.1811 0.935303C19.5825 0.935303 17.7534 2.31693 17.738 4.29527C17.7216 5.75828 19.0437 6.57471 20.0399 7.0611C21.0642 7.55938 21.4084 7.87849 21.4039 8.32402C21.3971 9.00631 20.5868 9.30676 19.8308 9.31866C18.5087 9.33957 17.7415 8.96192 17.13 8.67691L16.6536 10.9039C17.2677 11.186 18.4016 11.4312 19.578 11.4437C22.3396 11.4437 24.1465 10.0791 24.1555 7.96631ZM13.2653 1.12124L9.00561 11.2848H6.22596L4.12988 3.17357C4.0025 2.674 3.89184 2.49128 3.50485 2.28058C2.87339 1.93799 1.82953 1.61598 0.911133 1.41654L0.973861 1.12124H5.44749C6.01751 1.12124 6.53059 1.50082 6.65991 2.15737L7.76714 8.03901L10.503 1.12124H13.2653Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.0dda9857437b74518575f63ae40765a4.svg";
export { ForwardRef as ReactComponent };